import React, { HTMLAttributes } from 'react';
import bemBlock from '@gik/core/utils/bemBlock';

export interface IGridProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  cols?: number;
}

export default function Grid({ cols, className, children, ...otherProps }: IGridProps): React.ReactElement {
  const bem = bemBlock('grid');
  const blockClasses = bem(null, null, [className, cols ? `gik-grid-${cols}-cols` : '']);

  return (
    <div {...otherProps} className={blockClasses}>
      {children}
    </div>
  );
}
